"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = exports.List = exports.MenuContainer = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const theme_1 = require("@monorepo/theme");
exports.MenuContainer = styled_components_1.default.div ``;
exports.List = styled_components_1.default.ul `
  display: flex;
  flex-direction: row;
  list-style: none;
  justify-content: center;

  ${theme_1.media.md `
        flex-direction: column;
        text-align: center;
    `}

  ${theme_1.media.xs `
        flex-direction: column;
        text-align: center;
    `}
`;
exports.ListItem = styled_components_1.default.li `
  margin-left: 6rem;
  color: ${theme_1.colors.white};
  cursor: pointer;

  ${theme_1.media.md `
        margin-left: 0 !important;
    `}

  ${theme_1.media.xs `
        margin-left: 0 !important;
    `}
`;
